export const SET_PAGE = 'SET_USER';
export const SET_CASES = 'SET_CASES';
export const SET_CURRENT_CASE = 'SET_CURRENT_CASE';
export const SET_CURRENT_SELECTION = 'SET_CURRENT_SELECTION';



// WEBPACK FOOTER //
// ./src/actions/types.js